module.exports = __webpack_public_path__ + "img/homeCustoms.7c06b012.png";